$(document).ready(function () {

    if (!$('#about-us-container').length) {
      return;
    }

    $('.news-carousel').slick({
    // dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          // dots: true
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          // infinite: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          infinite: false,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.owl-carousel').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
    // responsive: [{
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //       infinite: true,
    //       arrows: true,
    //       // dots: true
    //     }
    //   },
    //   {
    //     breakpoint: 750,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //       arrows: false,
    //       centerMode: true,
    //       // infinite: false,
    //     }
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       arrows: false,
    //       centerMode: true,
    //       infinite: false,
    //     }
    //   }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    // ]
  });
})
